import React, { useState, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface CopyToClipboardProps {
  text: string;
  title?: string;
  size?: 'small' | 'medium' | 'large';
}

export default function CopyToClipboard({ text, title = 'Copy to clipboard', size = 'small' }: CopyToClipboardProps) {
  const [tooltipText, setTooltipText] = useState(title);

  const handleCopy = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setTooltipText('Copied!');
      setTimeout(() => setTooltipText(title), 2000);
    } catch (err) {
      setTooltipText('Failed to copy');
      setTimeout(() => setTooltipText(title), 2000);
    }
  }, [text, title]);

  return (
    <Tooltip title={tooltipText}>
      <IconButton onClick={handleCopy} size={size} sx={{ p: 0.5 }}>
        <ContentCopyIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
}
